/**
 * C24 Quick-Add Sizes
 * Inline size picker for product grid items.
 * Lives inside the <a> link for correct positioning.
 * Uses capture-phase click handler to intercept and prevent navigation.
 */
(function() {
  'use strict';

  function init() {
    // Capture phase — fires BEFORE the <a> link gets the click
    document.addEventListener('click', function(e) {

      // 1. Click on size button → add to cart, block navigation
      var sizeBtn = e.target.closest('.c24-quick-add__size');
      if (sizeBtn) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (!sizeBtn.disabled) {
          addToCart(sizeBtn);
        }
        return false;
      }

      // 2. Click on mobile trigger → toggle sizes, block navigation
      var trigger = e.target.closest('[data-quick-add-trigger]');
      if (trigger) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var quickAdd = trigger.closest('[data-quick-add]');
        if (quickAdd) {
          document.querySelectorAll('[data-quick-add].is-active').forEach(function(el) {
            if (el !== quickAdd) el.classList.remove('is-active');
          });
          quickAdd.classList.toggle('is-active');
        }
        return false;
      }

      // 3. Click anywhere on quick-add container → block navigation
      var quickAddEl = e.target.closest('[data-quick-add]');
      if (quickAddEl) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
      }

      // 4. Click outside → close mobile panels
      document.querySelectorAll('[data-quick-add].is-active').forEach(function(el) {
        el.classList.remove('is-active');
      });
    }, true); // TRUE = capture phase, fires before bubble phase
  }

  function addToCart(btn) {
    if (btn.classList.contains('is-loading')) return;

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    btn.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: parseInt(variantId, 10),
        quantity: 1
      })
    })
    .then(function(response) { return response.json(); })
    .then(function(data) {
      btn.classList.remove('is-loading');

      if (data.status === 422) {
        btn.classList.add('c24-quick-add__size--sold-out');
        btn.disabled = true;
        return;
      }

      // Success flash
      btn.classList.add('is-added');
      setTimeout(function() { btn.classList.remove('is-added'); }, 1200);

      // Close mobile panel
      var quickAdd = btn.closest('[data-quick-add]');
      if (quickAdd) quickAdd.classList.remove('is-active');

      // Open cart drawer — Motion theme listens for both events
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: { product: data },
        bubbles: true
      }));
      setTimeout(function() {
        document.dispatchEvent(new CustomEvent('cart:open'));
      }, 100);
    })
    .catch(function(err) {
      console.error('C24 Quick-Add error:', err);
      btn.classList.remove('is-loading');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
